import { artFallback } from '~/utils/artFallback'

/**
 * 📱 M3 (mobile gameplan): poster fallbacks. In the apps most creature,
 * enemy and boss LOOPS stream from the art host while their posters and
 * stills ship in the bundle, so a loop that cannot load - the phone is
 * offline, the host is down - would leave a broken image on the field, the
 * resolution card or the inspector. One capturing listener catches every
 * failed <img> on the page (error events do not bubble, but they do pass
 * the capture phase) and swaps in the bundled stand-in (utils/artFallback.ts).
 * A poster or still that fails has no stand-in, so nothing loops. Loops
 * preloaded through `new Image()` (CreatureIdle) never reach the document
 * and keep their own handling. Harmless on the web, where a single missing
 * loop now shows its poster too.
 */
export default defineNuxtPlugin(() => {
  document.addEventListener('error', (event) => {
    const img = event.target
    if (!(img instanceof HTMLImageElement)) return
    const failed = img.currentSrc || img.src
    const fallback = failed ? artFallback(failed) : null
    if (fallback && fallback !== failed) img.src = fallback
  }, true)
})
